import React, {ChangeEvent} from 'react';
import Box from "./Box";

export function FileInput(
        {
            disabled,
            visible,
            onClick,
            sx,
            customComponent: CustomComponent = <></>,
        }: {
            visible?: boolean,
            disabled?: boolean,
            onClick: (files: FileList) => void,
            sx?: any,
            customComponent: any,

        }) {

    const input = React.createRef<HTMLInputElement>();

    function handleClick() {
        if (!disabled) {
            input.current?.click();
        }
    }


    if (visible === false) {
        return null;
    }

    return <Box
            style={{
                cursor: "pointer",
            }}
            onClick={handleClick}
            sx={sx}
    ><input
            ref={input}
            style={{
                display: "none",
            }}
            type={'file'}
            multiple
            onChange={(evt: ChangeEvent<HTMLInputElement>) => {
                if (evt.target.files) {
                    onClick(evt.target.files);
                    evt.target.value = "";
                }

            }}
    />
        <CustomComponent/>
    </Box>
}
